/* eslint-disable linebreak-style */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable max-len */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/prop-types */
/* eslint-disable import/extensions */
import React from 'react';

import { Fade } from 'react-awesome-reveal';
// eslint-disable-next-line import/no-extraneous-dependencies
import * as emailjs from '@emailjs/browser';
// eslint-disable-next-line import/no-extraneous-dependencies
import { ToastContainer, toast } from 'react-toastify';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-toastify/dist/ReactToastify.css';

import { Form } from 'elements/Form';
import Button from 'elements/Button';
import { ORG_NAME } from '../constants';

// EmailJS credentials copied verbatim from the intro-company template.
// IMPORTANT: these are the template's original keys (Drava Studio's account).
// Submissions will currently route to that inbox until the keys below are
// replaced with credentials from a Balance Point Studios EmailJS account.
const EMAILJS_SERVICE_ID = 'service_h4gtndg';
const EMAILJS_TEMPLATE_ID = 'template_a9tvs7a';
const EMAILJS_PUBLIC_KEY = 'user_csqIxzN5mKsl1yw4ffJzV';

const ROLE_OPTIONS = [
  { value: '', label: 'I am a…' },
  { value: 'volunteer', label: 'Volunteer' },
  { value: 'mentor', label: 'Mentor applicant' },
  { value: 'parent', label: 'Parent / family' },
  { value: 'partner', label: 'Partner organization' },
  { value: 'donor', label: 'Donor / sponsor' },
  { value: 'other', label: 'Something else' },
];

export const DiscussForm = (actions) => {
  const { data, resetForm } = actions;

  const submitEmail = () => {
    const {
      name, email, role, message,
    } = data;

    if (!name || !email || !role || !message) {
      toast.error('Please fill out your name, email, role, and message.');
      return;
    }

    if (!EMAILJS_SERVICE_ID || !EMAILJS_TEMPLATE_ID || !EMAILJS_PUBLIC_KEY) {
      toast.error('Email service is not configured yet. Please email us directly for now.');
      return;
    }

    const templateParams = {
      from_name: `${name} (${role})`,
      reply_to: email,
      to_name: ORG_NAME,
      message,
    };

    emailjs
      .send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams, EMAILJS_PUBLIC_KEY)
      .then(
        () => {
          toast.success("Thank you. We will be in touch.");
          resetForm();
        },
        () => {},
      );
  };

  const handleRoleChange = (event) => {
    actions.onChange({ target: { name: 'role', value: event.target.value } });
  };

  return (
    <section className="flex flex-col container mx-auto mt-10 justify-center px-4">
      <Fade direction="down" triggerOnce>
        <h1 className="text-4xl md:text-5xl text-theme-blue text-center font-serif font-bold">
          Get Involved
        </h1>
      </Fade>

      <Fade direction="up" triggerOnce>
        <p className="font-light text-lg text-gray-500 text-center mb-12 max-w-2xl mx-auto">
          Tell us a little about yourself and the young person you want to connect, the role you want
          to play, or the partnership you want to explore. We read every message.
        </p>
      </Fade>

      <Fade direction="up" triggerOnce>
        <div className="flex flex-col">
          <div className="flex flex-col sm:flex-row mx-auto">
            <Form
              id="name"
              name="name"
              type="text"
              value={data.name}
              placeholder="Your name"
              className=""
              onChange={actions.onChange}
            />
            <Form
              id="email"
              name="email"
              type="email"
              value={data.email}
              placeholder="Your email address"
              className=""
              onChange={actions.onChange}
            />
          </div>

          <div className="flex flex-col mb-6 mx-auto w-95 sm:w-192 lg:w-192.5 xl:w-192.5 px-2">
            <select
              id="role"
              name="role"
              value={data.role}
              onChange={handleRoleChange}
              aria-label="Your role"
              className="p-4 font-light text-lg text-theme-blue rounded border border-gray-400 focus:outline-none focus:ring-1 focus:ring-theme-purple bg-white"
              required
            >
              {ROLE_OPTIONS.map((option) => (
                <option key={option.value} value={option.value} disabled={option.value === ''}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          <div className="mx-auto">
            <Form
              id="message"
              name="message"
              type="textarea"
              value={data.message}
              placeholder="Tell us about yourself, the young person you want to enroll, or the partnership you want to explore."
              className=""
              onChange={actions.onChange}
            />
          </div>
          <Button
            className="text-xl mx-auto px-12 py-3 mt-5 bg-theme-purple text-white rounded-full border-2 border-theme-purple hover:bg-dark-theme-purple transition duration-200 focus:outline-none cursor-pointer"
            type="button"
            onClick={submitEmail}
          >
            Send message
          </Button>
        </div>
      </Fade>

      <ToastContainer />
    </section>
  );
};
